import UsersProvider from './Users.provider';
import { Title } from '#shared/components/UI';
import UsersList from './UsersList/UsersList';
import { UsersHostProps } from './types';

// The feature root: takes the host props and mounts the feature-local provider, so every internal
// component's useUsers() resolves. Hosts render it from the shared/users entry:
// <UsersPage {...useUsersHostProps()} />.
export default function UsersPage({
  title,
  titleLevel,
  titlePlacement = 'above',
  viewer,
  account,
  userPermissions,
  tableContainer,
  permissionCatalogSource,
  createRoleInSubAccounts,
  updateRoleInSubAccounts,
  countSubAccounts,
  deleteRoleFromSubAccounts,
}: UsersHostProps) {
  return (
    <UsersProvider
      viewer={viewer}
      account={account}
      userPermissions={userPermissions}
      tableContainer={tableContainer}
      permissionCatalogSource={permissionCatalogSource}
      createRoleInSubAccounts={createRoleInSubAccounts}
      updateRoleInSubAccounts={updateRoleInSubAccounts}
      countSubAccounts={countSubAccounts}
      deleteRoleFromSubAccounts={deleteRoleFromSubAccounts}
    >
      {titlePlacement === 'inline' ? (
        <UsersList title={title} titleLevel={titleLevel} />
      ) : (
        <div>
          {title && <Title level={titleLevel}>{title}</Title>}
          <UsersList />
        </div>
      )}
    </UsersProvider>
  );
}
